// UsageTracker.js - Fire-and-forget usage event tracker
// Sends events to the Synergy Usage API: https://lna.pos.co.zm/SynergyApi/api/v1/usage/record
// See docs/references/usage-tracking.md for the full payload contract.

let appKey = 'kdiy-1777981450768';

export function initUsageTracker(key) {
    appKey = key;
}

export async function recordUsage(feature, action, userId = null, extras = {}) {
    try {
        const payload = {
            app_key: appKey,
            feature: feature,
            action: action,
            ...extras
        };
        if (userId) payload.user_id = userId;

        const response = await fetch('https://lna.pos.co.zm/SynergyApi/api/v1/usage/record', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload)
        });
        return await response.text();
    } catch (err) {
        // Fire-and-forget: never throw to the caller
        console.warn('[UsageTracker] Failed:', err);
        return null;
    }
}

// Auto-initialize with the KDIY app key
initUsageTracker('kdiy-1777981450768');
